import { render, staticRenderFns } from "./NotificationNavbar.vue?vue&type=template&id=68cea04e&scoped=true"
import script from "./NotificationNavbar.vue?vue&type=script&lang=js"
export * from "./NotificationNavbar.vue?vue&type=script&lang=js"
import style0 from "./NotificationNavbar.vue?vue&type=style&index=0&id=68cea04e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cea04e",
  null
  
)

export default component.exports